import { gql } from '@apollo/client'
import { PASSAGE_FIELDS } from './practiceTest'

export const GET_ONE_QUESTION_BANK = gql`
  ${PASSAGE_FIELDS}
  query findOneQuestionBank($params: String!) {
    findOneQuestionBank(id: $params) {
      id
      title
      questionBankCategory {
        id
        title
        membershipLevel
        subject {
          id
          tabName
          slug
          platform {
            id
            title
          }
        }
      }
      passage {
        ...PassageFields
      }
      questionIds
      order
      isLive
      history {
        updatedBy
        updatedAt
      }
      createdAt
      updatedAt
    }
    findQuestionByRelation(relationId: $params, relationName: qb) {
      id
      type
      title
      questionAsHtml
      questionCategory {
        id
      }
      answer {
        id
        isCorrect
        textAsHtml
        order
      }
    }
  }
`

export const CREATE_QUESTION_BANK = gql`
  mutation createQuestionBank($params: CreateQuestionBankInput!) {
    createQuestionBank(createQuestionBankInput: $params) {
      id
    }
  }
`

export const UPDATE_QUESTION_BANK = gql`
  mutation updateQuestionBank($params: UpdateQuestionBankInput!) {
    updateQuestionBank(updateQuestionBankInputFieldName: $params) {
      id
    }
  }
`

export const DELETE_QUESTION_BANK = gql`
  mutation removeQuestionBank($params: String!) {
    removeQuestionBank(id: $params) {
      affected
    }
  }
`

export const SEARCH_QUESTION_BANK = gql`
  query searchQuestionBank($searchString: String) {
    searchQuestionBank(searchString: $searchString) {
      count
      items {
        id
        title
      }
    }
  }
`

export const BULK_UPDATE_QUESTION_BANK = gql`
  mutation bulkUpdateQuestionBank($params: [BulkUpdateQuestionBankInput!]!) {
    bulkUpdateQuestionBank(bulkUpdateQuestionBankInput: $params) {
      id
    }
  }
`
